
import React from 'react';
import { motion } from 'framer-motion';
import { formatCurrency } from '@/lib/utils';
import { CheckCircle2 } from 'lucide-react';

const FixedContributionDisplay: React.FC = () => {
  const fixedAmount = 500000;
  
  return (
    <div className="rounded-lg bg-gradient-to-r from-lime-100 to-emerald-100 p-4 border border-lime-200">
      <div className="flex flex-col space-y-2">
        <div className="flex items-center justify-between">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
            className="flex items-center space-x-2"
          >
            <CheckCircle2 className="w-5 h-5 text-emerald-600" />
            <span className="text-lg font-semibold text-emerald-800">Đóng góp cơ bản:</span>
          </motion.div>
          <motion.span
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            className="text-lg font-bold text-emerald-700"
          >
            {formatCurrency(fixedAmount.toString())}
          </motion.span>
        </div>
        
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="text-sm text-emerald-700 bg-white bg-opacity-50 p-2 rounded"
        >
          Bao gồm áo thun đồng phục kỷ niệm 20 năm và tiệc họp mặt.
        </motion.p>
      </div>
    </div>
  );
};

export default FixedContributionDisplay;
